import React from 'react';
import PageContainer from '../components/PageContainer';

function About() {
  return (
    <PageContainer>
      <h1>About Häl Music</h1>
      <p>
        At HÄL Music, we revolutionize the way artists achieve professional-grade song mixes. Leveraging our cutting-edge diffusion + cross-attention machine learning model, we deliver mixing services that rival top engineers—at a fraction of the cost and nearly instantaneously. Artists remain in control, describing their desired mix style, whether it’s “warm and saturated” or “clean and crisp,” and our model brings their creative vision to life. HÄL Music is where artistry meets innovation, empowering musicians with the tools to perfect their sound effortlessly.
      </p>
    </PageContainer>
  );
}

export default About;
